import { FC } from 'react'

import { Memo } from '@hoc/Memo'
import { CoreProvider } from './core'

import { RegistrationApp } from './modules'
import { Toast } from '@components/Toast'

export const App: FC = Memo(() => {
  return (
    <CoreProvider>
      <RegistrationApp />
      <Toast />
    </CoreProvider>
  )
})
